import { File, FilePdf } from '@phosphor-icons/react';

import { determineFileType } from '../utils';
import type { ExtendedFile } from '../types';
import { Image } from 'components/image/Image';

/** Small icon or thumbnail for a file row (not a full document preview — see {@link FilePreview}). */
export const FileIconPreview = ({ file, size }: { file: ExtendedFile; size: number }) => {
  const type = determineFileType(file);

  if (type === 'pdf') return <FilePdf data-testid="icon_pdf" size={size} />;
  if (type === 'text') return <FilePdf data-testid="icon_text" size={size} />;
  if (type === 'image')
    return (
      <Image
        data-testid="image_preview"
        src={file.preview}
        width={32}
        height={32}
        sx={{ borderRadius: 1, overflow: 'hidden' }}
        fit="cover"
        role="presentation"
      />
    );

  return <File data-testid="icon_default" size={size} />;
};
